export const BRAZE_STORAGE_KEY = 'ab.storage.cc';
export const BRAZE_NEW_HOME_ALERT_CARD_TYPE = 'newHomeAlert';
export const BRAZE_NEW_HOME_ALERT_CARD_TARGET = 'consumer';
export const BREAKOUT_PRICE_K = 1000;
export const BREAKOUT_PRICE_M = 1000000;
